<template>
	<div class="banner3">
		<img :class="banner3containtImg + ' ' + logoAni + ' ' + logoLeftAni"
			src="../../assets/logo/lw.png">
		<slider @change="changepage" v-model="sliderIndex" :touch="true" :interval="5000" :speed="1000" :autoplay="true" :control-btn="false"
			animation="normal" class="bannerSwiper" style="height: 60vh; width: 90vw;">
			<!-- Market Insights -->
			<slider-item class="slideritem">
				<p class="title">
					{{$t('banner3.slide1.title')}}
				</p>
				<p class="desc">
					<span>
						{{$t('banner3.slide1.desc1')}}
					</span>
					<br />
					<span>{{$t('banner3.slide1.desc2')}}</span>
				</p>
			</slider-item>
			<!-- Funding Support -->
			<slider-item class="slideritem">
				<p class="title">
					{{$t('banner3.slide2.title')}}
				</p>
				<p class="desc">
					<span>
						{{$t('banner3.slide2.desc1')}}
					</span>
					<br />
					<span>{{$t('banner3.slide2.desc2')}}</span>
				</p>
			</slider-item>
			<!-- Feasibility Study -->
			<slider-item class="slideritem">
				<p class="title">
					{{$t('banner3.slide3.title')}}
				</p>
				<p class="desc">
					<span>
						{{$t('banner3.slide3.desc1')}}
					</span>
					<br />
					<span>{{$t('banner3.slide3.desc2')}}</span>
				</p>
			</slider-item>
			<!-- Art Production -->
			<slider-item class="slideritem">
				<p class="title">
					{{$t('banner3.slide4.title')}}
				</p>
				<p class="desc">
					<span>
						{{$t('banner3.slide4.desc1')}}
					</span>
					<br />
					<span>
						{{$t('banner3.slide4.desc2')}}
					</span>
				</p>
			</slider-item>
		</slider>
		<div class="banner3containtText">
			{{$t('banner3.stoketext')}}
		</div>

	</div>
</template>

<script>
	import {
		Slider,
		SliderItem
	} from 'vue-easy-slider'
	export default {
		props: ['curpage', 'aniDownUp'],
		components: {
			Slider,
			SliderItem
		},
		watch: {
			'curpage': {
				handler(newvalue, oldvalue) {
					this.logoAni = ''
					this.logoLeftAni = ''
					this.sliderIndex = 0
					if (newvalue === 3) {
						this.curIndex = 0
						if (this.aniDownUp == 'down') { // 从第二页进入当前页面
							this.logoAni = 'banner3containtImgAni'
							this.banner3containtImg = 'banner3containtImg'
						} else {
							this.logoAni = ''
							this.logoLeftAni = ''
							this.banner3containtImg = 'banner3containtImg2'
						}
					} else {
						this.logoAni = ''
						this.logoLeftAni = ''
						this.banner3containtImg = 'banner3containtImg2'
						if (this.aniDownUp == 'down') { // 跳转到下一页
							this.logoAni = 'logoBottomtAni'
						} else {
							this.logoAni = ''
						}
					}
				},
				immediate: true
			},
			'aniDownUp': {
				handler(newvalue, oldvalue) {
					// console.log(newvalue, 'aniDownUp')
				},
				immediate: true
			}
		},
		data() {
			return {
				sliderIndex: 0,
				logoAni: '', // 
				logoLeftAni: '',
				curIndex: 0, // 从其他页面刚进入这个页面的时候，不做往右的动画
				banner3containtImg: '' // 从上往下进入页面的时候默认在顶部 banner3containtImg 从下往上进入页面的时候，默认在中间 banner3containtImg2
			}
		},
		methods: {
			changepage (page) {
				this.curIndex = 0
				if (this.curpage == 3) {
					this.curIndex += 1
					if (this.curIndex > 0) {
						this.logoLeftAni = 'banner3containtImgAniLeft'
						this.logoAni = ''
						this.banner3containtImg = 'banner3containtImg2'
						setTimeout(() => {
							this.logoLeftAni = ''
						}, 1000)
					}
				} else {
					this.curIndex = 0
					this.logoLeftAni = ''
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	/deep/ .slider-btn {
		display: none !important;
	}

	/deep/ .slider-indicator-icon {
		background-color: rgba(0, 0, 0, 0) !important;
		margin: 1px 0.1rem !important;
		border: 1px solid #fff !important;
		width: 10px !important;
		height: 10px !important;
	}

	/deep/ .slider-indicator-active {
		background-color: #fff !important;
	}

	.banner3 {
		height: 100vh;
		// background-image: url('../../assets/bg.jpg');
		background-repeat: no-repeat;
		background-size: 100%;
		background-size: cover;
		text-align: left;
		box-sizing: border-box;
		font-family: 'PilatTest-Bold';
		padding: 2.575rem 1.25rem;
		padding-left: 1.5625rem;
		background-color: #000;
		position: relative;
		.banner3containtText {
			position: absolute;
			bottom: 2.25rem;
			font-size: 1.575rem;
			-webkit-text-stroke: 1px #fff;
			-webkit-text-fill-color: transparent;
			font-family: 'PilatTest-Bold';
		}
		.banner3containtImg {
			width: 2.4rem;
			position: absolute;
			top: 0%;
			left: 5.2%;
			opacity: 0;
		}
		.banner3containtImg2 {
			width: 2.4rem;
			position: absolute;
			top: 23%;
			left: 5.2%;
		}
		.banner3containtImgAni {
			animation: gotoBottomAni 1s;
			animation-fill-mode: forwards;
			animation-delay: 0.5s;
			-webkit-animation-fill-mode: forwards;
			/* Safari 和 Chrome */
		}
		.logoBottomtAni {
			animation: logoBottomtAni 0.5s;
			animation-fill-mode: forwards;
			// animation-delay: 0.5s;
			-webkit-animation-fill-mode: forwards;
		}
		.banner3containtImgAniLeft {
			animation: gotoLeftAni 1s;
			animation-fill-mode: forwards;
			-webkit-animation-fill-mode: forwards;
			// animation-delay: 5s;
		}
		.bannerSwiper {
			
			display: flex;
			box-sizing: border-box;
			position: absolute;
			bottom: 0.625rem;
			.slideritem {
				width: 100%;
				height: 100%;
				box-sizing: border-box;
				// left: 1.125rem;
				box-sizing: border-box;
				font-family: 'PilatTest-Bold';
				font-size: 2.1875rem;
				font-weight: 700;
				// margin-top: 1.5rem;
				height: auto;
				color: #fff;

				p {
					box-sizing: border-box;
					padding: 0.325rem 0;
				}

				.title {
					font-size: 1.125rem;
					width: 100%;
				}

				.desc {
					width: 100%;
					// width: 80%;
					font-size: 0.55rem;
				}
			}
		}
	}

	@keyframes gotoBottomAni {
		10% {
			top: 0;
			opacity: 0;
		}

		100% {
			top: 23%;
			opacity: 1;
		}
	}
	@keyframes gotoLeftAni {
		10% {
			top: 23%;
		}
		50% {
			left: 25%;
			top: 23%;
		}
		100% {
			top: 23%;
			left: 5.2%;
			// right: 
			// opacity: 1;
		}
	}
	@keyframes logoBottomtAni {
		10% {
			top: 23%;
			opacity: 1;
			// left: 5.2%;
		}
		// 50% {
		// 	left: 5.2%;
		// 	top: 34%;
		// }
		100% {
			top: 100%;
			left: 5.2%;
			// right: 
			opacity: 0;
		}
	}
</style>
